import angular from 'angular';

import orgSelectComponent from './orgSelect.component';
import './orgSelect.component.scss';


export default angular.module('petroCloud.base.orgSelect', [])
  .component(orgSelectComponent.name, orgSelectComponent)
  .name;
